var version = "19.2.1";

export { version };
